import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { fetchSessionStatus } from "../../utils/sessionAuth";
import {
  buildInviteCheckoutPath,
  buildLoginRedirectForCheckout,
  persistPendingInviteOrderId,
  readInviteOrderId,
} from "../../utils/invitePaymentFlow";

export default function InvitePaymentLanding() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const orderId = useMemo(() => readInviteOrderId(searchParams), [searchParams]);

  useEffect(() => {
    if (!orderId) {
      setError("Enlace de pago no válido.");
      return undefined;
    }

    const checkoutPath = buildInviteCheckoutPath(orderId);
    if (!checkoutPath) {
      setError("Enlace de pago no válido.");
      return undefined;
    }

    persistPendingInviteOrderId(orderId);

    let active = true;
    (async () => {
      try {
        const { authenticated } = await fetchSessionStatus();
        if (!active) {
          return;
        }
        if (authenticated) {
          navigate(checkoutPath, { replace: true });
          return;
        }
        navigate(buildLoginRedirectForCheckout(orderId), { replace: true });
      } catch {
        if (!active) {
          return;
        }
        setError("No se pudo preparar el acceso al pago. Inténtalo de nuevo.");
      }
    })();

    return () => {
      active = false;
    };
  }, [navigate, orderId]);

  if (error) {
    return (
      <div style={{ maxWidth: 480, margin: "48px auto", padding: 16, textAlign: "center" }}>
        <p style={{ color: "#b91c1c" }}>{error}</p>
        <button
          type="button"
          onClick={() => {
            if (orderId) {
              navigate(buildLoginRedirectForCheckout(orderId), { replace: true });
              return;
            }
            navigate("/login", { replace: true });
          }}
        >
          Ir a iniciar sesión
        </button>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 480, margin: "48px auto", padding: 16, textAlign: "center" }}>
      <p>Preparando tu acceso al pago…</p>
    </div>
  );
}
